/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Status_ConfirmedInputs */

const en_coaching_status_confirmed = /** @type {(inputs: Coaching_Status_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmed`)
};

const id_coaching_status_confirmed = /** @type {(inputs: Coaching_Status_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terkonfirmasi`)
};

/**
* | output |
* | --- |
* | "Confirmed" |
*
* @param {Coaching_Status_ConfirmedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const coaching_status_confirmed = /** @type {((inputs?: Coaching_Status_ConfirmedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Status_ConfirmedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_coaching_status_confirmed(inputs)
	return en_coaching_status_confirmed(inputs)
});